<template>
    <div>
        <v-card :loading="(cargando)?'orange':null" loader-height="8px" elevation="0">
            <v-toolbar color="#ef6b01" rounded="0" elevation="5" class="fixed-bar">
                <v-btn icon dark @click="atras"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                <v-card-title style="color:#ffff">Acceso rápido</v-card-title>
            </v-toolbar>
            <div class="ml-2 mr-2 mt-5 text-center">
                <v-text-field autofocus type="search" v-model="busqueda" color="orange" prepend-inner-icon="mdi-magnify" 
                    label="Buscar Producto"
                    outlined
                    clearable
                    clear-icon="fas fa-times"
                ></v-text-field>
            </div>
            <div style="margin-inline: 15px;" class="mb-12 mt-1" >
                <v-list three-line v-if="this.articulosFiltrados.length>0" >
                    <template v-for="(item, index) in articulosFiltrados" >
                        
                        <v-list-item  @change="(agregarCarrito==false)? clicArt(item): ''" :key="item.COD_ART" v-ripple="{ class: 'orange--text' }" >
                        
                        <v-list-item-avatar :rounded="true" size="80px" horizontal  style="overflow: visible">
                            <Imagen v-if="item.imagen" :src="item.imagen" :src2="item.etiqueta"/>
                        </v-list-item-avatar>
                        

                        <v-list-item-content>
                            {{(item.DESC_CLIENTE)?item.DESC_CLIENTE:item.DESCRIPCION}}
                            <v-list-item-subtitle v-if="item.texto_acceso_rapido"><span><b>Acceso rápido: </b><b style="color:orange;font-size:17px">{{item.texto_acceso_rapido}}</b></span></v-list-item-subtitle>
                            <v-list-item-subtitle><span><b>Código: </b><b style="color:orange;font-size:17px">{{item.COD_ART}}</b></span></v-list-item-subtitle>
                            <v-list-item-subtitle><span><b>Empaque: </b><b style="color:orange;font-size:17px">{{(item.ESCALA!=item.ESC)?item.ESCALA:''}} {{(item.ALQ_CANT_USO_DIARIO) ? item.ALQ_CANT_USO_DIARIO : item.CANT_EMPAQ}} {{item.ESC}}</b></span></v-list-item-subtitle>
                            
                            <v-list-item-subtitle v-if="usuario.muestra_lista==1 && !item.COL_PRI_ID"><span><b>Precio por {{ item.ESC_UNI }} contado: </b><b style="color:orange;font-size:17px">{{precioArt(item) | toCurrency}}</b></span><span v-if="precioConIva" style="color:orange;font-size: 13px;">{{` más IVA (${porcentajeIva(item)}%)`}}</span></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="(item.CANT_EMPAQ!=1 || item.ALQ_CANT_USO_DIARIO>0) && usuario.muestra_lista==1 && !item.COL_PRI_ID"><span><b>Precio por {{ item.ESC_EMP }} contado: </b><b style="color:orange;font-size:17px">{{precioPorEmpaque(item) | toCurrency}}</b></span><span v-if="precioConIva" style="color:orange;font-size: 13px;">{{` más IVA (${porcentajeIva(item)}%)`}}</span></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="articulosCotizacion.find(x=>x.cod_art==item.COD_ART) && !item.COL_PRI_ID" style="color: red;">Por más de {{ articulosCotizacion.find(x=>x.cod_art==item.COD_ART).cantidad }} {{ item.ESC_PLU.toLowerCase() }}, solicitar cotización </v-list-item-subtitle>
                            <v-row class="mt-2 d-flex align-center flex-wrap">
                                <v-col cols="auto" class="ma-1" v-if="articulosCotizacion.find(x=>x.cod_art==item.COD_ART) && !item.COL_PRI_ID">
                                <v-btn @click.stop="verDialogCotizar(item)" elevation="0" outlined small dark color="orange"><font-awesome-icon style="font-size:20px" icon="dollar-sign"/>Cotizar</v-btn>
                                </v-col>

                                <v-col cols="auto" class="ma-1" v-if="item.COL_PRI_ID==1 ">
                                    <v-btn @click.stop="itemCotizar = item, dialogCotizarItem = true, cantCotizarItem = 1, cantMinimaCotizar = 1" elevation="0" outlined small dark color="orange"><font-awesome-icon style="font-size:20px" icon="dollar-sign"/>Cotizar</v-btn>
                                </v-col>

                                <v-col cols="auto" class="ma-1" v-if="item.COL_SEC_ID==1">
                                    <v-btn @click.stop="generarFinanciacion(item)" elevation="0" outlined small dark color="orange"><font-awesome-icon style="font-size:20px" icon="comment-dollar"/>Financiación</v-btn>
                                </v-col>

                                <v-col cols="auto" class="ma-1" v-if="!item.COL_PRI_ID">
                                    <div style="justify-content: end; display: grid;">
                                    <v-btn v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)==-1)" color="orange" @click="agregarCarrito=true,agregar(item)" elevation="0" outlined small dark><font-awesome-icon style="font-size:20px" icon="cart-shopping"/>{{(usuario.muestra_lista==1)?'Agregar':'Cotizar'}}</v-btn>
                                        <template v-if="(carrito.findIndex(i => i.cod_art==item.COD_ART)!=-1)">
                                            <p style="color:green;margin: 0px;" class="mt-2"><v-icon style="font-size:20px" color="green">mdi-cart-check</v-icon>Agregado al carrito</p>
                                            <div class="cantidad-controls mt-3">
                                                <v-btn color="orange" fab icon small @click="cantidadMenos(item)"><v-icon>mdi-minus-thick</v-icon></v-btn>
                                                <v-text-field
                                                v-model="carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad"
                                                label="Cantidad"
                                                type="number"
                                                dense
                                                flat
                                                solo
                                                color="orange"
                                                hide-details="true"
                                                style="max-width: 95px;"
                                                @click="verDialogCantidad(carrito[carrito.findIndex(i => i.cod_art==item.COD_ART)])"
                                                class="centered-input text-orange cantidad-input"
                                                readonly
                                                ></v-text-field>
                                                <v-btn color="orange" fab icon small @click="cantidadMas(item)"><v-icon>mdi-plus-thick</v-icon></v-btn>
                                            </div>
                                            <p class="mt-2" style="color:orange;text-align: center;max-width: 168px;">{{descEmpaque(item)}}</p>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                            
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn icon @click.stop="quitarAccesoRapido(item)">
                                <v-icon color="grey lighten-1">mdi-star-off</v-icon>
                            </v-btn>
                        </v-list-item-action>

                        </v-list-item>
                        <v-divider :key="index" :inset="item.inset"></v-divider>
            
                    </template>
                </v-list>
                <template v-if="this.articulosFiltrados.length==0 && !this.cargando">
                    <p style="text-align: center; margin-top:50px" ><v-icon>mdi-information-outline</v-icon> No hay artículos de acceso rápido</p>
                </template>
            </div>
            <!--FOOTER---------------->
            <v-footer color="#ef6b01" padless fixed class="mt-5" style="justify-content: end" rounded="0">
            <v-row justify="center" no-gutters style="height: 45px;">
                <v-col cols="4">

                </v-col>
                <v-col cols="4" class="text-center">
                    <v-btn style="bottom: 23px;" fab color="#ef6b01" elevation="20" @click="irHome" class="my-2"><font-awesome-icon style="font-size:25px;color: white" icon="plus"/></v-btn>
                </v-col>
                <v-col cols="4" class="text-end">
                    <v-btn @click="irCarrito" icon class="my-1 mr-2" color="white"><font-awesome-icon style="font-size:22px;color: white;" icon="cart-shopping"/>{{(carrito.length>0)?carrito.length:''}}</v-btn>
                </v-col>
            </v-row>
        </v-footer>
        </v-card>
         <!-- DIALOG CANTIDAD -->
        <v-dialog v-model="dialogCantidad" max-width="300px" persistent>
            <v-card v-if="itemCantSelected">
                <v-toolbar color="#ef6b01">
                    <v-btn icon dark @click="cerrarDialogCambiarCantidad"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                    <v-card-title style="color:#ffff">Cambiar cantidad</v-card-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3" v-if="itemCantSelected">
                    <v-text-field autofocus outlined style="font-size: 20px;" v-model="carrito[carrito.findIndex(i => i.cod_art==itemCantSelected.cod_art)].cantidad" label="Cantidad" type="number" solo color="orange" @focus="$event.target.select()"></v-text-field>
                    <p v-if="sinDisponibilidadCantidad" style="color:red;text-align:center;margin:0">Sin disponibilidad para esa cantidad</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="itemCantSelected" color="orange" elevation="5" outlined @click="cambiarCantidad()" :disabled="!validarCantidad">Aceptar</v-btn>
                    <v-btn color="grey" elevation="5" @click="cerrarDialogCambiarCantidad" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- DIALOG COTIZAR ITEM -->
        <v-dialog v-model="dialogCotizarItem" max-width="300px" persistent>
            <v-card v-if="itemCotizar">
                <v-toolbar color="#ef6b01">
                    <v-btn icon dark @click="dialogCotizarItem"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                    <v-card-title style="color:#ffff">Cantidad a cotizar</v-card-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-3">
                    <v-text-field autofocus outlined style="font-size: 20px;" :min="cantMinimaCotizar" v-model="cantCotizarItem" label="Cantidad" type="number" solo color="orange"></v-text-field>
                    <p style="color:orange;text-align: center;max-width: 168px;">{{descEmpaque(itemCotizar,cantCotizarItem || 1)}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn  color="orange" elevation="5" outlined  :disabled="!cantCotizarItem || cantCotizarItem<cantMinimaCotizar" @click="cotizarItem">Aceptar</v-btn>
                    <v-btn color="grey" elevation="5" @click="dialogCotizarItem = false" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
            <!-- ----CARGANDO------- -->
            <v-overlay :value="cargando">
                <v-row>
                        <v-col class="text-center">
                            <v-progress-circular
                                indeterminate
                                size="70"
                                width="7"
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-center">
                            <span>Generando cotización</span>
                        </v-col>
                    </v-row>
            </v-overlay>
            
        </v-dialog>
         <!-- DIALOG FINANCIACION ENVIADA -->
        <v-dialog v-model="dialogFinanciacionExito" max-width="600px" persistent>
            <v-card class="mx-auto">
                <div style="padding: 10px;">
                    <p  style="font-weight: 600; font-size: larger;"><v-icon color="orange">mdi-check-circle</v-icon> ¡Gracias por tu interés!</p>
                    <span>Nos contactaremos para presentarte todas las opciones de financiación disponibles</span>
                </div>
                <v-card-actions>
                    <v-btn color="grey" elevation="5" @click="dialogFinanciacionExito = false" outlined>Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <!-- ----CARGANDO------- -->
        <v-overlay :value="cargando">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
            ></v-progress-circular>
        </v-overlay>
        <!-- SNACKBAR -->
        <v-snackbar v-model="snackbar" :color="snackbarColor" text outlined class="mb-15">
            {{ snackbarMsge }}
            <template v-slot:action="{ attrs }">
                <v-btn icon :color="snackbarColor" text v-bind="attrs" @click="snackbar = false"><v-icon>{{snackbarIcon}}</v-icon></v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import ApiServer from '../api';
import {mapState,mapActions} from 'vuex'
import Imagen from '../components/Imagen.vue'
import moment from 'moment'
import * as stockGrupo from '../stockGrupo'
export default {
    name:'AccesoRapido',
    components:{Imagen},
    data(){
        return{
            articulos:[],
            articulosFiltrados:[],
            cargando:false,
            agregarCarrito:false,
            itemCantSelected: null,
            dialogCantidad: false,
            busqueda: null,
            cargandoArticulos: false,
            articulosCotizacion:[],
            dialogCotizarItem:false,
            itemCotizar:null,
            cantCotizarItem: null,
            cantMinimaCotizar: 1,
            dialogFinanciacionExito: false,
            snackbar:false,
            snackbarColor:'error',
            snackbarMsge:'',
            snackbarIcon:'mdi-check-circle',
        }
    },
    methods:{
        ...mapActions(['agregarAlCarrito','editarCantCarrito','borrarArtCarrito']),
        obtenerGrupoStockId(item){
            return stockGrupo.obtenerGrupoStockId(item)
        },
        obtenerDisponible(item){
            return stockGrupo.obtenerDisponibleEnUnidades(item)
        },
        obtenerEmpaque(item){
            return stockGrupo.obtenerEmpaque(item)
        },
        cantidadTotalGrupoEnCarrito(grupoId, codArtExcluir = null){
            return stockGrupo.cantidadTotalGrupoEnCarrito(this.carrito, grupoId, codArtExcluir)
        },
        puedeAsignarCantidadPorGrupo(item, cantidadDeseada){
            return stockGrupo.puedeAsignarCantidadPorGrupo(item, cantidadDeseada, this.carrito)
        },
        disponibleGrupoParaItem(item){
            return stockGrupo.disponibleGrupoParaItem(item, this.carrito)
        },
        async clicArt(item){
            try {
                await ApiServer.postUsoLog({
                   cod_cli: this.usuario.cod_cli,
                   usuario: this.usuario.nombreUsuario,
                   accion: 'ARTICULO_ACCESO_RAPIDO',
                   dato: item.COD_ART
               })
                this.$router.push({name: 'Articulo', params: { codArt: item.COD_ART,datosArticulo:item }});
            } catch (error) {
                console.log(error);
            }
        },
        async quitarAccesoRapido(item){
            this.cargando = true
            try {
                await ApiServer.deleteAccesoRapido(this.usuario.cod_cli, item.COD_ART)
                this.articulos = this.articulos.filter(a => a.COD_ART !== item.COD_ART)
                this.articulosFiltrados = this.articulosFiltrados.filter(a => a.COD_ART !== item.COD_ART)
                this.snackbar = true
                this.snackbarColor = 'success'
                this.snackbarIcon = 'mdi-check-circle'
                this.snackbarMsge = 'Acceso rápido eliminado'
            } catch (error) {
                console.log(error)
                this.snackbar = true
                this.snackbarColor = 'error'
                this.snackbarIcon = 'mdi-close-circle'
                this.snackbarMsge = 'No se pudo eliminar el acceso rápido'
            } finally {
                this.cargando = false
            }
        },
        async agregar(item){
            this.cargando = true
            try {
                if(!this.puedeAsignarCantidadPorGrupo(item,1)){
                    this.cargando = false
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                    return
                }
                let result = await ApiServer.postCarritoCliente({
                    cod_cli:this.usuario.cod_cli,
                    cod_art:item.COD_ART,
                    cantidad: 1,
                    lpr_id:item.LISTA_ID,
                    usuario: this.usuario.nombreUsuario,
                    accion:'CARRITO_ACCESO_RAPIDO'
                });
                this.agregarAlCarrito({
                    id:result.insertId,
                    lpr_id:item.LISTA_ID,
                    cod_art:item.COD_ART,
                    art_id:item.ART_ID,
                    desc_cliente: item.DESC_CLIENTE,
                    descripcion: item.DESCRIPCION,
                    mod:item.MOD,
                    med:item.MED,
                    desc_if:item.DESC_IF,
                    cantidad:1,
                    escala_id:item.ESCALA_ID,
                    escala:item.ESCALA,
                    esc:item.ESC,
                    esc_plu:item.ESC_PLU,
                    esc_uni: item.ESC_UNI,
                    esc_emp: item.ESC_EMP,
                    pr_vta:item.PR_VTA,
                    pr_cto_cpra:item.PR_CTO_CPRA,
                    pr_cto:item.PR_CTO,
                    pr_final:item.PR_FINAL,
                    descuento:item.DESCUENTO,
                    disponible:item.DISPONIBLE,
                    cant_empaq:item.CANT_EMPAQ,
                    alq_cant_uso_diario: item.ALQ_CANT_USO_DIARIO,
                    ord_rec_str:item.ORD_REC_STR,
                    ean:item.EAN,
                    imagen : `https://loguin.com.ar/img/${item.ART_ID}.jpg?t=${(new Date()).getTime()}`,
                    etiqueta : item.etiqueta,
                    peso: item.PESO
                })
                this.cargando = false
            } catch (error) {
                this.cargando = false
                console.log(error);
            }
            setTimeout(()=>{
                this.agregarCarrito=false
            },1000)
          
        },
        async cantidadMas(item){
            this.agregarCarrito = true
            this.cargando = true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                let cant = this.carrito[index].cantidad+1
                if(this.puedeAsignarCantidadPorGrupo(this.carrito[index],cant)){
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                    this.cargando = false
                    setTimeout(()=>{
                        this.agregarCarrito=false
                    },2000)
                }else{
                    this.cargando = false
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                }
                
            } catch (error) {
                console.log(error);
                this.cargando = false
            }
        },
        async cantidadMenos(item){
            this.cargando = true
            this.agregarCarrito=true
            try {
                let index = this.carrito.findIndex(i => i.cod_art==item.COD_ART)
                if(index>=0){
                    if(this.carrito[index].cantidad>1){
                        let cant = this.carrito[index].cantidad-1
                        await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                        this.editarCantCarrito({index:index,cantidad:cant})
                    }else{
                        await ApiServer.deleteCarritoCliente(this.carrito[index].id)
                        this.borrarArtCarrito(this.carrito[index].id)
                    }
                }
                this.cargando = false
                setTimeout(()=>{
                    this.agregarCarrito=false
                },2000)
            } catch (error) {
                 console.log(error);
                this.cargando = false
            }
        },
        verDialogCantidad(item){
            this.agregarCarrito=true
            this.itemCantSelected = item
            this.dialogCantidad = true
            setTimeout(()=>{
                this.agregarCarrito=false
            },2000)
        },
        async cambiarCantidad(){
            this.dialogCantidad = false
            this.cargando = true
            let cant = Number(this.itemCantSelected.cantidad)
            try {
                if(this.puedeAsignarCantidadPorGrupo(this.itemCantSelected,cant)){
                    let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
                    await ApiServer.putCarritoCliente({cantidad:cant,id:this.carrito[index].id})
                    this.editarCantCarrito({index:index,cantidad:cant})
                }else{
                    this.snackbar = true
                    this.snackbarColor ='error'
                    this.snackbarIcon = 'mdi-close-circle'
                    this.snackbarMsge='Sin stock compartido disponible'
                }
                this.cargando = false
                this.itemCantSelected = null
            } catch (error) {
                this.cargando = false
                this.dialogCantidad = false
                this.itemCantSelected = null
                console.log(error);
            }
        },
        cerrarDialogCambiarCantidad(){
            let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
            if(index>=0){
                if(!this.puedeAsignarCantidadPorGrupo(this.itemCantSelected,this.carrito[index].cantidad)){
                    const maxUnidadesActual = this.disponibleGrupoParaItem(this.itemCantSelected)
                    this.carrito[index].cantidad = Math.floor(maxUnidadesActual / this.obtenerEmpaque(this.itemCantSelected))
                }
                let cant = this.carrito[index].cantidad * this.obtenerEmpaque(this.carrito[index])
                if(cant<=0){
                    this.carrito[index].cantidad = 1
                }
                this.dialogCantidad = false
            }
            this.itemCantSelected = null
        },
        atras(){
            this.$router.go(-1)
        },
        irCarrito(){
            this.$router.push({name: 'Carrito'});
        },
        irHome(){
            this.$router.push({name: 'Home'});
        },
        descEmpaque(item,cant){
            
            let empaque = item.ALQ_CANT_USO_DIARIO || item.CANT_EMPAQ
            if(!cant){
                cant = this.carrito[this.carrito.findIndex(i => i.cod_art==item.COD_ART)].cantidad || 1
            }
            if(cant==1){
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESCALA} / ${cant * empaque} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESCALA}`
                }
            }else{
                if(item.ESCALA != item.ESC){
                    return `${cant} ${item.ESC_PLU} / ${cant * empaque} ${item.ESC}`
                }else{
                    return `${cant} ${item.ESC_PLU}`
                }
            }
        },
        porcentajeIva(item){
            //IVA 10.5 o 21
            let x = item.PR_FINAL/item.PR_VTA
            if(Math.abs(21-(x-1)*100)<Math.abs(10.5-(x-1)*100)){
                return 21
            }else{
                return 10.5
            }
        },
        precioArt(item){
            let precio = null
            if(this.precioConIva){
                precio = item.PR_VTA + item.PR_VTA*(item.DESCUENTO/100)
            }else{
                precio = item.PR_FINAL + item.PR_FINAL*(item.DESCUENTO/100)
            }
            if(item.ALQ_CANT_USO_DIARIO){ //si ALQ_CANT_USO_DIARIO es != NULL entonces el precio del articulo es el precio por empaque
                precio = precio / item.ALQ_CANT_USO_DIARIO
            }
            return Math.round(precio)
        },
        precioPorEmpaque(item){
            let precio = null
            if(this.precioConIva){
                let pr_vta= item.PR_VTA + item.PR_VTA*(item.DESCUENTO/100)
                if(item.ALQ_CANT_USO_DIARIO){//si ALQ_CANT_USO_DIARIO es != NULL el precio ya es por empaque
                    precio = Math.round(pr_vta)
                }else{
                    precio = Math.round(pr_vta)*item.CANT_EMPAQ
                }
            }else{
                let pr_final = item.PR_FINAL + item.PR_FINAL*(item.DESCUENTO/100)
                if(item.ALQ_CANT_USO_DIARIO){//si ALQ_CANT_USO_DIARIO es != NULL el precio ya es por empaque
                    precio = Math.round(pr_final)
                }else{
                    precio = Math.round(pr_final)*item.CANT_EMPAQ
                }
            }
            return precio
        },
        verDialogCotizar(item){
            this.itemCotizar = item
            this.cantMinimaCotizar = this.articulosCotizacion.find(x=>x.cod_art==item.COD_ART).cantidad
            this.cantCotizarItem = this.articulosCotizacion.find(x=>x.cod_art==item.COD_ART).cantidad
            this.dialogCotizarItem = true
        },
        async cotizarItem(){
            try {
                this.cargando = true
                let cliente = []
                let result = await ApiServer.getDatosCliente(this.usuario.cod_cli)
                if(result.length>0){
                    let index = result.findIndex(x=>x.DOM_CLASIF_ID.trim()=='DE')
                    if(index>=0){
                        cliente = result[index]
                    }else{
                        cliente = result[0]
                    }
                }
                //TALONARIO
                let talonario = await ApiServer.getTalonarios(259);
                await ApiServer.putTalonarios(259)//TALONARIOS.NRO_CPR + 1
                let fecha = moment().format('DD-MM-YYYY')
                fecha = fecha.replace('-','.')
                fecha = fecha.replace('-','.')
                try {
                    let cpr_id = await ApiServer.getCprIdProcedure()
                    await ApiServer.postCpr({
                        id_pp:cpr_id.CPR_ID,
                        cpretc:11,
                        cprclasif:0,
                        cpr_tipo:"PR",
                        pv:talonario[0].NRO,
                        nro:talonario[0].NRO_CPR,
                        cpr_letra:"X",
                        tal_id:259,
                        fecha: fecha,
                        cli_id:this.usuario.cli_id,
                        rz:cliente.RZ,
                        cuit:cliente.CUIT,
                        iva_id:cliente.IVA_ID.trim(),
                        actividad:cliente.IB_ACTIV_ID,
                        dom:cliente.DOM,
                        loc_id:cliente.LOC_ID,
                        loc:cliente.LOCALIDAD,
                        cp:cliente.CP,
                        prov_id:cliente.PROVINCIA_ID,
                        tipo_pago_id:"CO",
                        lista_id:0,
                        lista:'LISTA BASE',
                        nota_cpr:"",
                        cond_id:'1',
                        computa_iva:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N',
                        discrimina_imp:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N'
                    })
                    //INSERTO CPRDET
                    try {
                        let MTOTAL = 0
                        let MTOTALN = 0
                        let IVA21 = 0
                        let IVA105 = 0
                        
                        let cprdet_id =await ApiServer.postCprDet({ //ME RETORNA EL CPRDET_ID
                            id_pp:cpr_id.CPR_ID,
                            art_id:this.itemCotizar.ART_ID,
                            cod_art:this.itemCotizar.COD_ART,
                            descripcion:this.itemCotizar.DESCRIPCION,
                            desc_cliente:this.itemCotizar.DESC_CLIENTE,
                            mod:this.itemCotizar.MOD,
                            med:this.itemCotizar.MED,
                            descif:this.itemCotizar.DESC_IF,
                            cant:(this.itemCotizar.CANT_EMPAQ==0)?(this.cantCotizarItem):(this.cantCotizarItem*this.itemCotizar.CANT_EMPAQ),
                            escala_id:this.itemCotizar.ESCALA_ID,
                            escala:this.itemCotizar.ESCALA,
                            lista_id:this.itemCotizar.LPR_ID,
                            pr_cto_cpra:this.itemCotizar.PR_CTO_CPRA,
                            pr_cto:this.itemCotizar.PR_CTO,
                            prfinal:this.itemCotizar.PR_FINAL,
                            pr_vta:this.itemCotizar.PR_VTA,
                            dep_id_org:33,
                            dep_id_dest:33,
                            porc_dr:0,
                            monto_dr:0
                        }) 
                        //INSERTO CPRDETIMP
                        let PRNETO = this.itemCotizar.PR_VTA
                        let PRFINAL = this.itemCotizar.PR_FINAL
                        let IMPU=0
                        let IMP_ID=0
                        if(this.itemCotizar.CANT_EMPAQ>1){
                            PRNETO = this.itemCotizar.PR_VTA*this.itemCotizar.CANT_EMPAQ
                            PRFINAL = this.itemCotizar.PR_FINAL*this.itemCotizar.CANT_EMPAQ
                        }
                        if(((PRFINAL/PRNETO)-1.21)<=0.01){
                            IVA21=IVA21+(PRNETO*.21*(this.cantCotizarItem));
                            IMPU=21;
                            IMP_ID=1;
                        }
                        if(((PRFINAL/PRNETO)-1.105)<=0.01){
                            IVA105=IVA105+(PRNETO*.105*(this.cantCotizarItem));
                            IMPU=10.5;
                            IMP_ID=2;
                        }
                        await ApiServer.postCprdetImp({
                            cprdet_id:cprdet_id.CPRDET_ID,
                            imp_id:IMP_ID,
                            impu:IMPU,
                            neto_mas_iva:PRNETO*this.cantCotizarItem,
                            monto_iva:PRNETO*(IMPU/100)*(this.cantCotizarItem)
                        })
                        //SUMO LOS TOTALES
                        MTOTAL=MTOTAL+(PRFINAL)*(this.cantCotizarItem);
                        MTOTALN=MTOTALN+(PRNETO)*(this.cantCotizarItem);

                        
                        //INSERTO EL PIE DEL COMPROBANTE
                        try {
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'-1',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'0',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            if(IVA21>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'1',
                                impuesto:'IVA 21%',
                                clasif_id:'1',
                                porc:'21',
                                porcentaje:'0',
                                total_neto:IVA21,
                                total:IVA21/1.21,
                                });
                            }
                            if(IVA105>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'2',
                                impuesto:'IVA 10.5%',
                                clasif_id:'1',
                                porc:'10.5',
                                porcentaje:'0',
                                total_neto:IVA105,
                                total:IVA105/1.105,
                                }); 
                            }
                            try {
                                await ApiServer.putCprMonto(cpr_id.CPR_ID,{monto:MTOTAL})
                                try {
                                    //CAMBIAR EL ESTADO A CPR_EST_ID=1
                                    await ApiServer.putCprEstado(cpr_id.CPR_ID,{estado:'1'})
                                } catch (error) {
                                    this.cargando=false
                                    console.log(error)
                                    this.snackbar=true
                                    this.snackbarMsge="Se produjo un error al cambiar estado"
                                    this.snackbarColor="error"
                                    this.snackbarIcon='mdi-close-circle'
                                }
                            } catch (error) {
                                this.cargando=false
                                console.log(error)
                                this.snackbar=true
                                this.snackbarMsge="Se produjo un error al actualizar monto"
                                this.snackbarColor="error"
                                this.snackbarIcon='mdi-close-circle' 
                            }
                        } catch (error) {
                            this.cargando=false
                            console.log(error)
                            this.snackbar=true
                            this.snackbarMsge="Se produjo un error al generar cprpie"
                            this.snackbarColor="error"
                            this.snackbarIcon='mdi-close-circle'
                        }
                    } catch (error) {
                        this.cargando=false
                        console.log(error)
                        this.snackbar=true
                        this.snackbarMsge="Se produjo un error al generar cprdet"
                        this.snackbarColor="error"
                        this.snackbarIcon='mdi-close-circle'
                    }
                    this.cargando=false
                    this.snackbar=true
                    this.snackbarMsge="Gracias! Te enviaremos la cotización"
                    this.snackbarColor="success"
                    this.snackbarIcon='mdi-check-circle'
                    this.dialogCotizarItem = false
                    
                } catch (error) {
                    this.cargando=false
                    console.log(error)
                    this.snackbar=true
                    this.snackbarMsge="Se produjo un error al generar cpr"
                    this.snackbarColor="error"
                    this.snackbarIcon='mdi-close-circle'
                }
            } catch (error) {
                this.cargando=false
                console.log(error);
                this.snackbar = true
                this.snackbarColor ='error'
                this.snackbarIcon = 'mdi-close-circle'
                this.snackbarMsge='Se produjo un error'
            }
        },
        async generarFinanciacion(item){
            this.itemCotizar = item
            this.cantCotizarItem = 1
           try {
                this.cargando = true
                let cliente = []
                let result = await ApiServer.getDatosCliente(this.usuario.cod_cli)
                if(result.length>0){
                    let index = result.findIndex(x=>x.DOM_CLASIF_ID.trim()=='DE')
                    if(index>=0){
                        cliente = result[index]
                    }else{
                        cliente = result[0]
                    }
                }
                //TALONARIO
                let talonario = await ApiServer.getTalonarios(268);
                await ApiServer.putTalonarios(268)//TALONARIOS.NRO_CPR + 1
                let fecha = moment().format('DD-MM-YYYY')
                fecha = fecha.replace('-','.')
                fecha = fecha.replace('-','.')
                try {
                    let cpr_id = await ApiServer.getCprIdProcedure()
                    await ApiServer.postCpr({
                        id_pp:cpr_id.CPR_ID,
                        cpretc:11,
                        cprclasif:0,
                        cpr_tipo:"PR",
                        pv:talonario[0].NRO,
                        nro:talonario[0].NRO_CPR,
                        cpr_letra:"X",
                        tal_id:268,
                        fecha: fecha,
                        cli_id:this.usuario.cli_id,
                        rz:cliente.RZ,
                        cuit:cliente.CUIT,
                        iva_id:cliente.IVA_ID.trim(),
                        actividad:cliente.IB_ACTIV_ID,
                        dom:cliente.DOM,
                        loc_id:cliente.LOC_ID,
                        loc:cliente.LOCALIDAD,
                        cp:cliente.CP,
                        prov_id:cliente.PROVINCIA_ID,
                        tipo_pago_id:"CO",
                        lista_id:0,
                        lista:'LISTA BASE',
                        nota_cpr:"",
                        cond_id:'1',
                        computa_iva:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N',
                        discrimina_imp:(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI')?'S':'N'
                    })
                    //INSERTO CPRDET
                    try {
                        let MTOTAL = 0
                        let MTOTALN = 0
                        let IVA21 = 0
                        let IVA105 = 0
                        
                        let cprdet_id =await ApiServer.postCprDet({ //ME RETORNA EL CPRDET_ID
                            id_pp:cpr_id.CPR_ID,
                            art_id:this.itemCotizar.ART_ID,
                            cod_art:this.itemCotizar.COD_ART,
                            descripcion:this.itemCotizar.DESCRIPCION,
                            desc_cliente:this.itemCotizar.DESC_CLIENTE,
                            mod:this.itemCotizar.MOD,
                            med:this.itemCotizar.MED,
                            descif:this.itemCotizar.DESC_IF,
                            cant:(this.itemCotizar.CANT_EMPAQ==0)?(this.cantCotizarItem):(this.cantCotizarItem*this.itemCotizar.CANT_EMPAQ),
                            escala_id:this.itemCotizar.ESCALA_ID,
                            escala:this.itemCotizar.ESCALA,
                            lista_id:this.itemCotizar.LPR_ID,
                            pr_cto_cpra:this.itemCotizar.PR_CTO_CPRA,
                            pr_cto:this.itemCotizar.PR_CTO,
                            prfinal:this.itemCotizar.PR_FINAL,
                            pr_vta:this.itemCotizar.PR_VTA,
                            dep_id_org:33,
                            dep_id_dest:33,
                            porc_dr:0,
                            monto_dr:0
                        }) 
                        //INSERTO CPRDETIMP
                        let PRNETO = this.itemCotizar.PR_VTA
                        let PRFINAL = this.itemCotizar.PR_FINAL
                        let IMPU=0
                        let IMP_ID=0
                        if(this.itemCotizar.CANT_EMPAQ>1){
                            PRNETO = this.itemCotizar.PR_VTA*this.itemCotizar.CANT_EMPAQ
                            PRFINAL = this.itemCotizar.PR_FINAL*this.itemCotizar.CANT_EMPAQ
                        }
                        if(((PRFINAL/PRNETO)-1.21)<=0.01){
                            IVA21=IVA21+(PRNETO*.21*(this.cantCotizarItem));
                            IMPU=21;
                            IMP_ID=1;
                        }
                        if(((PRFINAL/PRNETO)-1.105)<=0.01){
                            IVA105=IVA105+(PRNETO*.105*(this.cantCotizarItem));
                            IMPU=10.5;
                            IMP_ID=2;
                        }
                        await ApiServer.postCprdetImp({
                            cprdet_id:cprdet_id.CPRDET_ID,
                            imp_id:IMP_ID,
                            impu:IMPU,
                            neto_mas_iva:PRNETO*this.cantCotizarItem,
                            monto_iva:PRNETO*(IMPU/100)*(this.cantCotizarItem)
                        })
                        //SUMO LOS TOTALES
                        MTOTAL=MTOTAL+(PRFINAL)*(this.cantCotizarItem);
                        MTOTALN=MTOTALN+(PRNETO)*(this.cantCotizarItem);

                        
                        //INSERTO EL PIE DEL COMPROBANTE
                        try {
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'-1',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'0',
                                porc:'0',
                                porcentaje:'0',
                                total_neto:MTOTALN,
                                total:MTOTAL
                            });
                            if(IVA21>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'1',
                                impuesto:'IVA 21%',
                                clasif_id:'1',
                                porc:'21',
                                porcentaje:'0',
                                total_neto:IVA21,
                                total:IVA21/1.21,
                                });
                            }
                            if(IVA105>=0.01){
                                await ApiServer.postCprpie({
                                cpr_id:cpr_id.CPR_ID,
                                impuesto_id:'2',
                                impuesto:'IVA 10.5%',
                                clasif_id:'1',
                                porc:'10.5',
                                porcentaje:'0',
                                total_neto:IVA105,
                                total:IVA105/1.105,
                                }); 
                            }
                            try {
                                await ApiServer.putCprMonto(cpr_id.CPR_ID,{monto:MTOTAL})
                                try {
                                    //CAMBIAR EL ESTADO A CPR_EST_ID=1
                                    await ApiServer.putCprEstado(cpr_id.CPR_ID,{estado:'1'})
                                } catch (error) {
                                    this.cargando=false
                                    console.log(error)
                                    this.snackbar=true
                                    this.snackbarMsge="Se produjo un error"
                                    this.snackbarColor="error"
                                    this.snackbarIcon='mdi-close-circle'
                                }
                            } catch (error) {
                                this.cargando=false
                                console.log(error)
                                this.snackbar=true
                                this.snackbarMsge="Se produjo un error"
                                this.snackbarColor="error"
                                this.snackbarIcon='mdi-close-circle' 
                            }
                        } catch (error) {
                            this.cargando=false
                            console.log(error)
                            this.snackbar=true
                            this.snackbarMsge="Se produjo un error"
                            this.snackbarColor="error"
                            this.snackbarIcon='mdi-close-circle'
                        }
                    } catch (error) {
                        this.cargando=false
                        console.log(error)
                        this.snackbar=true
                        this.snackbarMsge="Se produjo un error"
                        this.snackbarColor="error"
                        this.snackbarIcon='mdi-close-circle'
                    }
                    this.cargando=false
                    this.dialogFinanciacionExito = true
                    
                    
                } catch (error) {
                    this.cargando=false
                    console.log(error)
                    this.snackbar=true
                    this.snackbarMsge="Se produjo un error"
                    this.snackbarColor="error"
                    this.snackbarIcon='mdi-close-circle'
                }
            } catch (error) {
                this.cargando=false
                console.log(error);
                this.snackbar = true
                this.snackbarColor ='error'
                this.snackbarIcon = 'mdi-close-circle'
                this.snackbarMsge='Se produjo un error'
            } 
        }
    },
    async mounted(){
        this.cargando = true
        this.cargandoArticulos = true
        try {
            let resultArt = await ApiServer.getAccesosRapidos(this.usuario.cod_cli)
            let etiquetas = await ApiServer.getEtiquetasProductos()
            let result = await ApiServer.getProductosPorCotizacion(this.usuario.cod_cli)
            this.articulosCotizacion = result
            for(const art of resultArt){
                let datosEncontrados = null

                for (const lista of this.usuario.listas) {
                    const resultDatosArt = await ApiServer.getArtLpr(art.cod_art, lista.LISTA_ID, this.usuario.cli_id, false)
                    if (resultDatosArt && resultDatosArt.length > 0) {
                        if (resultDatosArt[0].DISPONIBLE > 0) {
                            datosEncontrados = resultDatosArt[0]
                            break
                        }
                        if (!datosEncontrados) {
                            datosEncontrados = resultDatosArt[0]
                        }
                    }
                }
                if (!datosEncontrados) continue

                datosEncontrados.imagen=`https://loguin.com.ar/img/${datosEncontrados.ART_ID}.jpg`
                datosEncontrados.texto_acceso_rapido = art.texto
                let indexEtiqueta = etiquetas.findIndex(x=>x.cod_art==art.cod_art)
                if(indexEtiqueta>-1){
                    datosEncontrados.etiqueta = `https://loguin.com.ar/img/imag_etiquetas/${etiquetas[indexEtiqueta].etiqueta}?t=${(new Date()).getTime()}`
                }else{
                    datosEncontrados.etiqueta = null
                }
                if(datosEncontrados.CANT_EMPAQ == 0){
                    datosEncontrados.CANT_EMPAQ = 1
                }
                this.articulos.push(datosEncontrados)
                this.articulosFiltrados.push(datosEncontrados)
                if(!this.busqueda)
                this.cargando = false
            }

            this.cargandoArticulos = false
            if(this.cargando){
                this.cargando = false
            }
            if(this.busqueda!=null && this.busqueda!=''){
                let buscar = this.busqueda.toLowerCase()
                this.articulosFiltrados = this.articulos.filter(function(item){
                    if(item.texto_acceso_rapido && item.texto_acceso_rapido.toLowerCase().includes(buscar)){
                        return true
                    }
                    if(item.DESC_CLIENTE){
                        return (item.DESC_CLIENTE.toLowerCase().includes(buscar))
                    }else if(item.DESCRIPCION){
                        return (item.DESCRIPCION.toLowerCase().includes(buscar))
                    }else{
                        return false
                    }
                })
            }
        } catch (error) {
            this.cargando = false
            this.cargandoArticulos = false
            console.log(error);
        }
    },
    computed:{
        ...mapState(['usuario','carrito']),
        validarCantidad(){
            if(!this.itemCantSelected){
                return false
            }
            let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
            if(index>=0){
                return this.puedeAsignarCantidadPorGrupo(this.itemCantSelected,this.carrito[index].cantidad)
            }
            return false
        },
        sinDisponibilidadCantidad(){
            if(!this.itemCantSelected){
                return false
            }
            let index = this.carrito.findIndex(i => i.cod_art==this.itemCantSelected.cod_art)
            if(index < 0){
                return false
            }
            const cant = Number(this.carrito[index].cantidad)
            if(!cant || cant <= 0){
                return false
            }
            return !this.puedeAsignarCantidadPorGrupo(this.itemCantSelected, cant)
        },
        precioConIva(){
            if(this.usuario.iva_id=='MO' || this.usuario.iva_id=='RI'){
                return true
            }else{
                return false
            }
        },
        paltallaChica(){
            if(screen.width<420){
                return true
            }else{
                return false
            }
        }
    },
    watch:{
        busqueda(){
            if(!this.cargandoArticulos){
                if(this.busqueda == '' || this.busqueda==null){
                    this.articulosFiltrados = this.articulos
                }else{
                    let buscar = this.busqueda.toLowerCase()
                    this.articulosFiltrados = this.articulos.filter(function(item){
                        if(item.texto_acceso_rapido && item.texto_acceso_rapido.toLowerCase().includes(buscar)){
                            return true
                        }
                        if(item.DESC_CLIENTE){
                            return (item.DESC_CLIENTE.toLowerCase().includes(buscar))
                        }else if(item.DESCRIPCION){
                            return (item.DESCRIPCION.toLowerCase().includes(buscar))
                        }else{
                            return false
                        }
                    })
                }
            }else{
                this.cargando = true
            }
        },
    }
}
</script>
<style scoped>
    .centered-input >>> input {
      text-align: center;
      text-align-last: center;
    }
    .cant.v-text-field--outlined >>> fieldset {
    border-color: orange;
    border-width: 2px;
    height: 35px;
    align-self: start;
    margin-top: 6px
    }
     .fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0em;
    z-index: 2;
    }
    .cantidad-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        flex-wrap: nowrap;
    }
    .cantidad-input {
        flex-shrink: 0;
        min-width: 70px;
    }
</style>